// extracted by mini-css-extract-plugin
module.exports = {"list":"ProjectDetailsBlock_list__IV34B","row":"ProjectDetailsBlock_row__prH6O","colon":"ProjectDetailsBlock_colon__NobhQ"};